/**
 * 车辆档案中心
 */
import request from "@/utils/request";
import { exportFn } from "@/api/commonApi";

const base = "/ntocc-basic-api/vehicleArchive";

// 列表
export function getVehicleArchiveList(data) {
  return request({
    url: `${base}/list`,
    method: "get",
    params: data
  });
}

// 详情（code=vehicle.code）
export function getVehicleArchiveDetail(code) {
  return request({
    url: `${base}/detail`,
    method: "get",
    params: { code }
  });
}

// 枚举字典
export function getVehicleArchiveDict() {
  return request({
    url: `${base}/dict`,
    method: "get"
  });
}

// 新增（VehicleDTO 走 query 参数，与老 vehicle/addOrUpdate 传参一致）
export function addVehicle(data) {
  return request({
    url: `${base}/add`,
    method: "post",
    params: data
  });
}

// 编辑（code + 档案字段一并走 query 参数）
export function editVehicle(data) {
  return request({
    url: `${base}/edit`,
    method: "post",
    params: data
  });
}

// 认证（body JSON）
export function auditVehicle(data) {
  return request({
    url: `${base}/audit`,
    method: "post",
    data
  });
}

// 冻结
export function freezeVehicleArchive(code) {
  return request({
    url: `${base}/freeze`,
    method: "post",
    params: { code }
  });
}

// 解冻
export function unfreezeVehicleArchive(code) {
  return request({
    url: `${base}/unfreeze`,
    method: "post",
    params: { code }
  });
}

// 车辆上线
export function onNetVehicleArchive(code) {
  return request({
    url: `${base}/onNet`,
    method: "post",
    params: { code }
  });
}

// 批量入网（勾选车辆逐台入网验证）
export function batchOnNetVehicleArchive(codes) {
  return request({
    url: `${base}/batchOnNet`,
    method: "post",
    data: codes
  });
}

// 删除（未完成运单 / 已绑定司机由后端拦截）
export function deleteVehicleArchive(code) {
  return request({
    url: `${base}/delete`,
    method: "post",
    params: { code }
  });
}

// 导出（blob 流，调用方通过 download(blob, name) 触发浏览器下载）
export function exportVehicleArchive(params) {
  return exportFn(`${base}/export`, params, "get");
}
